(() => {
  const init = (root) => {
    if (!root || root.dataset.maisonStoryReady === 'true') return;
    root.dataset.maisonStoryReady = 'true';
    const progress = root.querySelector('[data-maison-story-progress]');
    const update = () => {
      if (!progress) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? window.scrollY / max : 0;
      progress.style.transform = `scaleX(${Math.min(1, Math.max(0, ratio))})`;
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    const video = root.querySelector('[data-maison-story-video]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    if (!video || reduced || saveData) return;
    const load = () => {
      if (video.dataset.loaded === 'true') return;
      video.querySelectorAll('source[data-src]').forEach((source) => { source.src = source.dataset.src; });
      video.dataset.loaded = 'true'; video.load();
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { load(); video.play().catch(() => {}); } else { video.pause(); }
      }), { rootMargin: '220px 0px', threshold: .05 });
      observer.observe(video);
    } else load();
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-maison-story]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
